import request from '@/utils/request'
// import { PaginationBack } from '@/types/common/pagination'
/**
 * 使用说明分页
 */
export const useExplainListType = () =>
  request({
    url: '/blackcat/manual/list/type',
    method: 'get',
  })
